/*=========================================================================================
  File Name: moduleTitleMutations.js
  Description: Title Module Mutations
==========================================================================================*/
import _ from "lodash";
export default {
	SET_TITLES(state, titles) {
		state.titles = titles;
	},
	SET_TITLE_CATEGORY_SIDEBAR_STATUS(state, value) {
		state.showTitleCategorySidebar = value;
	},
	ADD_NEW_TITLE(state, title) {
		state.titles.push(title);
	},
	UPDATE_TITLE(state, title) {
		const idx = _.findIndex(state.titles, { id: title.id });
		if (idx !== -1) {
			Object.assign(state.titles[idx], title);
		}
	},
	DELETE_TITLE(state, title) {
		const idx = _.findIndex(state.titles, { id: title.id });
		if (idx !== -1) {
			state.titles.splice(idx, 1);
		}
	},
	SET_ROLES(state, roles) {
		state.roles = roles;
	},
	NOTHING() {}
};
